import React, { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Context } from "../lib/Store";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var BackButton = function BackButton() {
  var _useContext = useContext(Context),
      state = _useContext[0],
      dispatch = _useContext[1];

  var _useState = useState(false),
      showLoadingScreen = _useState[0],
      setShowLoadingScreen = _useState[1];

  var router = useRouter();
  useEffect(function () {
    setShowLoadingScreen(false);
  }, [router]);

  var goBack = function goBack() {
    setShowLoadingScreen(true);
    var routes = state.slice();
    var currentRoute = routes.pop();
    var urlToNavigateTo = routes.pop();
    dispatch({
      type: 'navigate_back'
    });

    if (!urlToNavigateTo) {
      router.replace('/');
    } else {
      router.back();
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      onClick: function onClick() {
        return goBack();
      },
      className: "back-button-arrow",
      children: /*#__PURE__*/_jsx("i", {
        className: "pr-4 fas fa-arrow-left"
      })
    }), showLoadingScreen && /*#__PURE__*/_jsx("div", {
      className: "navigation-loader"
    })]
  });
};

export default BackButton;